import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase/config";
import { useAuthState } from "react-firebase-hooks/auth";
import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { toast } from "react-toastify";

const MyListings = () => {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // İlanları getir
  useEffect(() => {
    const fetchListings = async () => {
      try {
        if (!user) return;

        const q = query(
          collection(db, "listings"),
          where("userEmail", "==", user.email)
        );
        const querySnapshot = await getDocs(q);
        const listingsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          createdAt: doc.data().createdAt?.toDate() || new Date(),
        }));

        setListings(listingsData);
      } catch (err) {
        console.error("Error fetching listings:", err);
        setError("İlanlar yüklenirken bir hata oluştu");
      } finally {
        setLoading(false);
      }
    };

    fetchListings();
  }, [user]);

  // İlanı sil
  const handleDelete = async (listingId) => {
    if (window.confirm("Are you sure you want to delete this listing?")) {
      try {
        await deleteDoc(doc(db, "listings", listingId));
        setListings((prev) =>
          prev.filter((listing) => listing.id !== listingId)
        );
      } catch (err) {
        console.error("Error deleting listing:", err);
        alert("Error deleting listing");
      }
    }
  };

  // İlanı düzenle
  const handleEdit = (listingId) => {
    navigate(`/edit-listing/${listingId}`);
  };

  if (loading) {
    return (
      <div className='min-h-screen bg-[#F8F9FA] py-8'>
        <div className='max-w-6xl mx-auto px-4'>
          <div className='flex justify-center items-center h-64'>
            <div className='animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500'></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='min-h-screen bg-[#F8F9FA] py-8'>
        <div className='max-w-6xl mx-auto px-4'>
          <div className='text-center text-red-600 font-architects-daughter'>
            {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='min-h-screen bg-[#F8F9FA] py-8'>
      <div className='max-w-6xl mx-auto px-4'>
        <div className='flex justify-between items-center mb-8'>
          <h1 className='text-3xl font-bold font-architects-daughter text-[#212529]'>
            My Listings
          </h1>
          <button
            onClick={() => navigate("/create-listing")}
            className='bg-blue-600 text-white px-6 py-2 rounded-lg font-architects-daughter hover:bg-blue-700 transition-colors'>
            Create New Listing
          </button>
        </div>

        {listings.length === 0 ? (
          <div className='text-center py-12'>
            <p className='text-gray-600 font-architects-daughter mb-4'>
              You have no listings yet.
            </p>
            <button
              onClick={() => navigate("/create-listing")}
              className='text-blue-600 hover:text-blue-700 font-architects-daughter'>
              Create your first listing
            </button>
          </div>
        ) : (
          <div className='grid gap-6'>
            {listings.map((listing) => (
              <div
                key={listing.id}
                className='bg-white rounded-lg shadow-md p-6 transition-transform hover:scale-[1.01]'>
                <div className='flex justify-between items-start'>
                  <div>
                    <h2 className='text-xl font-bold font-architects-daughter mb-2'>
                      {listing.title || listing.companyName}
                    </h2>
                    <p className='text-gray-600 font-architects-daughter mb-2'>
                      {listing.location}
                    </p>
                    <p className='text-sm text-gray-500 font-architects-daughter'>
                      Posted on: {listing.createdAt.toLocaleDateString()}
                    </p>
                    <div className='mt-2'>
                      <span className='inline-block bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full font-architects-daughter'>
                        {listing.type === "job"
                          ? "Job Listing"
                          : listing.type === "housing"
                          ? "Housing Listing"
                          : "Unknown Type"}
                      </span>
                    </div>
                  </div>
                  <div className='flex space-x-3'>
                    <button
                      onClick={() => handleEdit(listing.id)}
                      className='text-blue-600 hover:text-blue-700 font-architects-daughter'>
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(listing.id)}
                      className='text-red-600 hover:text-red-700 font-architects-daughter'>
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyListings;
